export default "__VITE_PUBLIC_ASSET__58c934b1__"